import { defaultCtx } from "~/lib/AjaxCtx"

export default class FundaeService {
    constructor(ctx) {
        this.$http = ctx || defaultCtx
    }

    /**
     * Save the answers of the poll
     * returns the state of the activity
     */
    async save({ userActivityId, questionId, answer }) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/save`,
            {
                method: "POST",
                body: JSON.stringify({ questionId, answer }),
            }
        )
    }

    /**
     * Save the answers and finishes the poll
     * returns the state of the activity
     */
    async finish(userActivityId, answers) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/finish`,
            {
                method: "POST",
                body: JSON.stringify({ answers }),
            }
        )
    }
}
